import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface DialogProps extends KendoWidgetProps, kendo.ui.DialogOptions {
    children?: React.ReactNode;
}

export default class Dialog extends KendoBaseComponent<DialogProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.Dialog(domNode as Element, (props as kendo.ui.DialogOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
        }

        return (
            <div ref={this.elementRef}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-react-wrapper/src/dialog/index.tsx